import { useThree } from '@react-three/fiber';
import { useEffect } from 'react';
import * as THREE from 'three';
import { Object3D } from 'three';

interface MaterialWithTransparency extends THREE.Material {
  transparent: boolean;
  opacity: number;
}

export function DebugMesh({ targetObject }: { targetObject: Object3D }) {
  const state = useThree();

  useEffect(() => {
    const originalStates: {
      box: THREE.BoxHelper;
      mesh: THREE.SkinnedMesh;
      transparent: boolean;
      opacity: number;
    }[] = [];

    if (targetObject) {
      targetObject.traverse((object) => {
        if (object instanceof THREE.SkinnedMesh && object.visible) {
          const material = object.material as MaterialWithTransparency;

          // Create a box helper for the mesh to show boundingbox
          const box = new THREE.BoxHelper(object, 0xffff00);
          state.scene.add(box);

          // Store original state
          originalStates.push({
            box: box,
            mesh: object,
            transparent: material.transparent,
            opacity: material.opacity,
          });

          // Set the mesh to be transparent
          material.transparent = true;
          material.opacity = 0.3;
        }
      });
    }

    return () => {
      // Restore original states
      originalStates.forEach(({ box, mesh, transparent, opacity }) => {
        state.scene.remove(box);
        box.dispose();
        const material = mesh.material as MaterialWithTransparency;
        material.transparent = transparent;
        material.opacity = opacity;
      });
    };
  }, [state.scene, targetObject]);

  return null;
}
